export const CMS_ADMIN_TOKEN = "cms_admin_token";
export const CMS_ADMIN_USER = "cms_admin_user";
